import Radio from 'backbone.radio';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import AlertMixin from '@/mixins/alert';
import template from '@/../templates/device-detail-layout.hbs';
import device_tabs_template from '@/../templates/device-tabs.hbs';

var globalCh = Radio.channel('global');

var DeviceTabs = Marionette.View.extend({
    template: device_tabs_template,
    className: 'navbar navbar-default',
    ui: {
        details: '.details',
        logs: '.logs',
        history: '.history',
        data: '.data',
        items: 'li',
    },
    events: {
        'click a': function(e){
            e.preventDefault();
        },
        'click li': function(e){
            this.ui.items.removeClass('active');
        },
        'click @ui.details': 'show_details',
        'click @ui.logs': 'show_logs',
        'click @ui.history': 'show_history',
        'click @ui.data': 'show_data'
    },
    show_details: function(){
        this.ui.details.addClass('active');
        this.triggerMethod('tab:clicked', 'detail');
    },
    show_logs: function(){
        this.ui.logs.addClass('active');
        this.triggerMethod('tab:clicked', 'logs');
    },
    show_history: function(){
        this.ui.history.addClass('active');
        this.triggerMethod('tab:clicked', 'history');
    },
    show_data: function(){
        this.ui.data.addClass('active');
        this.triggerMethod('tab:clicked', 'data');
    }
});
var DeviceDetailLayout = Marionette.View.extend(AlertMixin).extend({
    template: Handlebars.compile(template),
    className: 'device-detail standard-layout',
    ui: {
        alerts: '.alerts',
        summary: '.summary',
        tabs: '.tabs',
        content: '.content',
        home: '.back-to-account'
    },
    regions: {
        summary: '@ui.summary',
        tabs: '@ui.tabs',
        content: '@ui.content',
        alerts: '@ui.alerts',
    },
    templateContext: function() {
        return {
            account_name: this.model.rel.get('owner').get('username')
        };
    },
    events: {
        'click @ui.home' : 'home',
    },
    home : function(e){
        e.stopPropagation();
        if (e.which === 1) {
            globalCh.request('home');
            return false;
        }
    },
    initialize: function(){
        globalCh.reply('layout_alert', this.alert.bind(this));
    },
    onRender: function(){
        var device_tabs = new DeviceTabs();
        this.showChildView('tabs', device_tabs);
    },
});

export default DeviceDetailLayout;

